import { __awaiter, __generator } from "tslib";
import { getDifferenceInDays } from '@office-start/date-utility';
import { getFirstUseTimestamp, isFirstUse } from './UserStorageService';
export function fullDaysSinceFirstVisit() {
    return __awaiter(this, void 0, void 0, function () {
        var firstUseTimestamp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, isFirstUse()];
                case 1:
                    if (_a.sent()) {
                        return [2 /*return*/, 0];
                    }
                    return [4 /*yield*/, getFirstUseTimestamp()];
                case 2:
                    firstUseTimestamp = _a.sent();
                    if (typeof firstUseTimestamp === 'undefined' || firstUseTimestamp < 0) {
                        return [2 /*return*/, -1];
                    }
                    return [2 /*return*/, Math.floor(getDifferenceInDays(firstUseTimestamp))];
            }
        });
    });
}
//# sourceMappingURL=fullDaysSinceFirstVisit.js.map